import { useState, useEffect } from "react";
import { fetchData } from "../Components/common/utils";
function AllVideos() {
  const [selectedVideoId, setSelectedVideoId] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/video/list";
      const result = await fetchData(url);
      if (result) {
        setSelectedVideoId(result.data.slice(0, 1));
        setVideoList(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);
  const handleVideoClick = (videoId) => {
    setSelectedVideoId(videoList.filter((item) => item.id === videoId));
  };
  return (
    <div className="container mt-5">
      {loading ? (
        <div
          style={{ height: "30em" }}
          className="mt-5 d-flex justify-content-center align-items-center"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row mt-5">
          <div className="col-md-12 video-height">
            {selectedVideoId.map((item, index) => (
              <div key={index} className="general-img ">
                <iframe
                  width="100%"
                  height="450"
                  src={`https://www.youtube.com/embed/${item.youtube_link}`}
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
                <div style={{ background: "#80808038" }} className="p-2">
                  <h6 className="m-0">{item.title} </h6>
                </div>
              </div>
            ))}
          </div>
          {videoList.map((video, index) => (
            <div className="col-md-3 col-sm-6 col-12 gap-3 mt-5 video-height ">
              <div
                key={index}
                style={{
                  position: "relative",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
              >
                <iframe
                  width="100%"
                  height="150"
                  src={`https://www.youtube.com/embed/${video.youtube_link}`}
                  frameBorder="0"
                  allowFullScreen
                  style={{ position: "relative", zIndex: 1 }}
                ></iframe>

                {/* Overlay div */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 2, // Ensures the overlay is above the iframe
                  }}
                  onClick={() => handleVideoClick(video.id)}
                ></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AllVideos;
